
import http from 'api/httpClient';

export type FuelType = 'diesel' | 'petrol';

export type FuelSidebarSortKey =
    | 'city'
    | 'current_rate'
    | 'change'
    | 'change_percentage';

export type FuelSidebarRow = {
    City: string;
    CurrentRate: number;
    Change: number;
    ChangePercentage: number;
    Sparkline: number[];
};

export type FuelSidebarResponse = {
    rows: FuelSidebarRow[];
    page: number;
    page_size: number;
    total_items: number;
    total_pages: number;
    has_previous: boolean;
    has_next: boolean;
};

export type FetchFuelSidebarRequest = {
    city?: string;
    fuel_type?: FuelType;
    page?: number;
    per_page?: number;
    sort_by?: "city" | "price";
    sort_order?: 'asc' | 'desc';
};


export async function fetchFuelSidebar(
    payload: FetchFuelSidebarRequest,
): Promise<FuelSidebarResponse> {
    return http.post('/api/v1/fuel/sidebar', payload);
}

export type FuelGraphPoint = {
    PriceDate: string;
    Price: number;
};

export type FuelAnalyticsSummary = {
    City: string;
    BaseRate: number;
    CurrentRate: number;
    Increase: number;
    IncreasePercentage: number;
    HighestRate: number;
    LowestRate: number;
    AverageRate: number;
    LargestDailyMove: number;
};

export interface FuelCityAnalyticsResponse {
    summary?: FuelAnalyticsSummary | null;
    graph_data: FuelGraphPoint[];
    message?: string | null;
}

export type FetchFuelCityAnalyticsRequest = {
    city: string;
    from_date: string;
    to_date: string;
    fuel_type?: FuelType;
};

export async function fetchFuelCityAnalytics(
    payload: FetchFuelCityAnalyticsRequest,
): Promise<FuelCityAnalyticsResponse> {
    return http.post('/api/v1/fuel/city-analytics', payload);
}